import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from "react";
import { useUser } from "./UserContext";
import { firestore } from "../utils/firebase";
import { onSnapshot, query, collection } from "firebase/firestore";

const PrivateRoomsContext = createContext(undefined);

export const usePrivateRooms = () => {
  const context = useContext(PrivateRoomsContext);
  if (!context) {
    throw new Error(
      "usePrivateRooms must be used within a PrivateRoomsProvider",
    );
  }
  return context;
};

export const PrivateRoomsProvider = ({ children }) => {
  const { currentUser } = useUser();
  const [privateRooms, setPrivateRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!currentUser) return;
    const docRef = query(
      collection(
        firestore,
        "private_rooms",
        currentUser.current_user_id || currentUser._id,
        "private_rooms",
      ),
    );
    const unsubscribe = onSnapshot(
      docRef,
      (docSnapshot) => {
        const privateRoomsData = docSnapshot.docs.map((doc) => ({
          ...doc.data(),
          _id: doc.id,
        }));
        setPrivateRooms(privateRoomsData);
        setLoading(false);
      },
      (err) => {
        setError(`Failed to listen to user changes: ${err.message}`);
        setLoading(false);
      },
    );
    return () => {
      unsubscribe();
    };
  }, [currentUser]);

  return (
    <PrivateRoomsContext.Provider
      value={{
        privateRooms,
        loading,
        error,
      }}
    >
      {children}
    </PrivateRoomsContext.Provider>
  );
};
